import React, { useState, useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-sNwiaBfD.js';
import 'next/router';
import useShowError from './hooks/useShowError.js';
import 'notistack';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import useItemListName from './hooks/useItemListName.js';
import { getCartSessionId } from './utils/cart.js';
import { processErrorMessage } from './utils/error.js';
import Loader from './components/Loader/index.js';
import { Q as Quantity$1 } from './QuantityForm-nYHoHPeB.js';

const Quantity = ({ item }) => {
    const { t } = useTranslation('');
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const [quantityUpdating, setQuantityUpdating] = useState(false);
    const [key, setKey] = useState(0);
    const { thunks: { cart: { updateItemQuantity }, }, data: { siteConfig: { accorTagging: { accorTaggingEnabled = false } = {} }, }, useDispatch, } = useContext(CoreContext);
    const itemListName = useItemListName('mini basket');
    const dispatch = useDispatch();
    const showError = useShowError();
    const onUpdateQuantity = async (quantity) => {
        setQuantityUpdating(true);
        const cartSessionId = getCartSessionId();
        const payload = {
            cart_id: cartSessionId,
            cart_item_id: Number(item.id),
            quantity,
            accorTaggingEnabled,
            itemListName,
        };
        const resultAction = await dispatch(updateItemQuantity(payload));
        if (updateItemQuantity.rejected.match(resultAction)) {
            const error = processErrorMessage(resultAction.payload.errorMessage, t);
            showError(error);
        }
        setQuantityUpdating(false);
    };
    return (React.createElement("div", { className: "quantity" }, quantityUpdating ? (React.createElement(Loader, null)) : (React.createElement("div", { key: key, className: "quantity-container" },
        React.createElement("span", { className: "cart-title" },
            tLabel('quantity'),
            ":"),
        React.createElement(Quantity$1, { quantity: item.quantity, labelExtra: item.product.name, onUpdateQuantity: onUpdateQuantity, setKey: setKey })))));
};

export { Quantity as Q };
//# sourceMappingURL=Quantity-CBiGIFk6.js.map
